import FormContainer from "../../../components/formContainer/FormContainer";
import InputWrapper from "../../../components/input/wrapper/InputWrapper";
import OverlayLoader from "../../../components/loader/OverlayLoader/OverlayLoader";
import Select from "../../../components/select/main/Select";
import { useLanguageContext } from "../../../context/LanguageContext";
import EVAApiHelper from "../../../helpers/EVAApiHelper";
import { StyledInput } from "../../../styles/InputStyles";
import {
  StyledFlexColumn,
  StyledFlexItem,
  StyledFlexRow,
} from "../../../styles/LayoutStyles";

function CapacityConfigsPageView({
  configData,
  submitError,
  onSubmit,
  onActiveChange,
  onTenantIdChange,
  onClientIdChange,
  onClientSecretChange,
  onOrganizationIdChange,
  onZoneIdChange,
  onDriverTypeIdChange,
}) {
  const { translate } = useLanguageContext();

  return (
    <OverlayLoader groups="capacity_configs_page_fetch">
      <FormContainer
        onSubmit={onSubmit}
        submitError={submitError}
        submitLoadingGroup={"capacity_configs_page_save"}
      >
        <StyledFlexColumn>
          <InputWrapper
            label={translate("eva.main.validation.attributes.active")}
            required
            error={EVAApiHelper.getResponseError("active", submitError)}
          >
            <Select
              options={[
                { value: true, label: translate("eva.main.general.yes") },
                { value: false, label: translate("eva.main.general.no") },
              ]}
              value={configData.active}
              onChange={onActiveChange}
            />
          </InputWrapper>

          <StyledFlexRow>
            <StyledFlexItem>
              <InputWrapper
                label={translate("eva.main.validation.attributes.client_id")}
                required
                error={EVAApiHelper.getResponseError("client_id", submitError)}
              >
                <StyledInput
                  type="text"
                  placeholder={translate(
                    "eva.main.validation.attributes.client_id",
                  )}
                  value={configData.client_id}
                  onChange={onClientIdChange}
                />
              </InputWrapper>
            </StyledFlexItem>

            <StyledFlexItem>
              <InputWrapper
                label={translate(
                  "eva.main.validation.attributes.client_secret",
                )}
                required
                error={EVAApiHelper.getResponseError(
                  "client_secret",
                  submitError,
                )}
              >
                <StyledInput
                  type="text"
                  placeholder={translate(
                    "eva.main.validation.attributes.client_secret",
                  )}
                  value={configData.client_secret}
                  onChange={onClientSecretChange}
                />
              </InputWrapper>
            </StyledFlexItem>
          </StyledFlexRow>

          <InputWrapper
            label={translate("eva.main.validation.attributes.tenant_id")}
            error={EVAApiHelper.getResponseError("tenant_id", submitError)}
          >
            <StyledInput
              type="text"
              placeholder={translate(
                "eva.main.validation.attributes.tenant_id",
              )}
              value={configData.tenant_id}
              onChange={onTenantIdChange}
            />
          </InputWrapper>

          <InputWrapper
            label={translate("eva.main.validation.attributes.organization_id")}
            error={EVAApiHelper.getResponseError(
              "organization_id",
              submitError,
            )}
          >
            <StyledInput
              type="text"
              placeholder={translate(
                "eva.main.validation.attributes.organization_id",
              )}
              value={configData.organization_id}
              onChange={onOrganizationIdChange}
            />
          </InputWrapper>

          <InputWrapper
            label={translate("eva.main.validation.attributes.zone_id")}
            error={EVAApiHelper.getResponseError("zone_id", submitError)}
          >
            <StyledInput
              type="text"
              placeholder={translate("eva.main.validation.attributes.zone_id")}
              value={configData.zone_id}
              onChange={onZoneIdChange}
            />
          </InputWrapper>

          <InputWrapper
            label={translate("eva.main.validation.attributes.drivertype_id")}
            error={EVAApiHelper.getResponseError("drivertype_id", submitError)}
          >
            <StyledInput
              type="text"
              placeholder={translate(
                "eva.main.validation.attributes.drivertype_id",
              )}
              value={configData.drivertype_id}
              onChange={onDriverTypeIdChange}
            />
          </InputWrapper>
        </StyledFlexColumn>
      </FormContainer>
    </OverlayLoader>
  );
}

export default CapacityConfigsPageView;
